const arr = [
  {
    titleOne: 'HELLO THERE',
    titleTwo: 'We Are Glint',
    colorOfTitleOne: 'black',
    colorOfTitleTwo: 'white',
    fontSizeOfTitleTwo: '80px',
    lineOpacity: '0.18',
    borderOfLine: '0.5px solid white',
    widthOfLine: '38%',
    letterSpaceOfTitleOne: '3px'
  },
  {
    titleOne: 'WHAT WE DO',
    titleTwo: 'We’ve got everything you need to launch and grow your business',
    colorOfTitleOne: '#39b54a',
    colorOfTitleTwo: 'black',
    fontSizeOfTitleTwo: '50px',
    lineOpacity: '0.06',
    borderOfLine: '0.5px solid black',
    widthOfLine: '60%',
    letterSpaceOfTitleOne: '3px'
  },
  {
    titleOne: 'RECENT WORKS',
    titleTwo: 'We love what we do, check out some of our latest works',
    colorOfTitleOne: '#39b54a',
    colorOfTitleTwo: 'white',
    fontSizeOfTitleTwo: '50px',
    lineOpacity: '0.05',
    borderOfLine: '0.5px solid white',
    widthOfLine: '60%',
    letterSpaceOfTitleOne: '3px'
  },
  {
    titleOne: 'OUR CLIENTS',
    titleTwo: 'Glint has been honored to partner up with these clients',
    colorOfTitleOne: '#39b54a',
    colorOfTitleTwo: 'black',
    fontSizeOfTitleTwo: '50px',
    lineOpacity: '0.05',
    borderOfLine: 'none',
    widthOfLine: '70%',
    letterSpaceOfTitleOne: '3px'
  },
  {
    titleOne: 'CONTACT US',
    titleTwo: 'Reach out for a new project or just say hello',
    colorOfTitleOne: '#39b54a',
    colorOfTitleTwo: 'white',
    fontSizeOfTitleTwo: '50px',
    lineOpacity: '0.05',
    borderOfLine: 'none',
    letterSpaceOfTitleOne: '3px'
  }
];

export default arr;
